<script>
import Cleave from "vue-cleave-component";
import { mapGetters } from "vuex";
import { mapFields } from "vuex-map-fields";
import { MDBContainer, MDBRow, MDBCol, MDBBtn } from "mdb-vue-ui-kit";
import { scroller } from "vue-scrollto/src/scrollTo";
import clientConfig from "/src/config/client";

export default {
  name: "ContributionPanel",

  components: {
    MDBContainer,
    MDBRow,
    MDBCol,
    MDBBtn,
    Cleave,
  },

  data() {
    return {
      clientConfig,
      currentContributions: false,
      otherSpareCashAmount: true,
      typedSpareCashAmount: 0,
      contributionsIsGreaterThanSalary: false,
      salaryBalance: 0,
      formatOptions: {
        contributions: {
          numeral: true,
          prefix: "$",
          numeralPositiveOnly: true,
          noImmediatePrefix: true,
          rawValueTrimPrefix: true,
          numeralIntegerScale: 9,
          numeralDecimalScale: 2,
        },
        number: {
          numericOnly: true,
          blocks: [2],
        },
      },
    };
  },

  computed: {
      ...mapFields([
      "contributionsAfterTax",
      "contributionsBeforeTax",
      "contributionsAfterTaxFrequency",
      "contributionsBeforeTaxFrequency",
      "spareCashAmount",
      "spareCashAmountFrequency",
      "superEngineConfig",
      "taxedFund",
      "employerContributionRate"
    ]),

    ...mapGetters([
      "annualContributionsAfterTax",
      "annualContributionsBeforeTax",
      "annualSpareCashAmount",
      "annualSalary",
      "activeTab",
      "isResultTabActive",
      "debugMode",
      "data",
    ]),
  },

  watch: {
    typedSpareCashAmount() {
      this.updateContributionAmount();
      this.salaryBalanceCheck();
    },

    contributionsAfterTax() {
      this.salaryBalanceCheck();
    },

    contributionsBeforeTax() {
     this.salaryBalanceCheck();
    },

    currentContributions(){
      if(this.currentContributions) {
        this.contributionsBeforeTax = 0;
        this.contributionsAfterTax = 0;
      }
    },

    activeTab(tabVal) {
      if (tabVal === 3) {
        this.salaryBalanceCheck();
        if(this.annualSpareCashAmount == 0 && this.typedSpareCashAmount != 0 ){
          this.typedSpareCashAmount = 0;
        }
      }
    }
  },

  methods: {
    triggerHeightCheck() {
      // Add slight delay otherwise incorrect height is read
      var rf = this;
      setTimeout(function () {
        rf.$refreshIframeHeight();
      }, 300);
    },

    clickToTab(tabNum) {
      const scrollTo = scroller();
      this.$store.commit("setActiveTab", tabNum);
      scrollTo("#ccApp");

      this.triggerHeightCheck();

      this.$gtag.event('click', {
        'event_category': 'navigation',
        'event_label': 'navigateTo' + tabNum,
        'value': 1
      });

      if (this.debugMode)
        console.log("GTAG Event: navigateTo" + tabNum);
    },

    // checkContributionAmt(el) {
    //   if (!(el.target.id === "btnradio4" && el.target.checked)) {
    //     this.otherSpareCashAmount = false;
    //   }
    // },

    updateContributionAmount() {
      if (this.otherSpareCashAmount) {
        this.$store.commit("updateSpareCashAmount", this.typedSpareCashAmount);
      }
    },

    updateContributionAmountDelayed() {
      var model = this;
      setTimeout(function() {
        if (model.otherSpareCashAmount) {
          model.$store.commit("updateSpareCashAmount", model.typedSpareCashAmount);
        }
      }, 200);
    },

    // refactor... to make it more universal for any target, not switch statement
    enforceTargetAmountMinMax(frequency, cashflowMax, target = false){

      switch(frequency) {
        case "week":
          cashflowMax = cashflowMax * clientConfig.params.frequency.week
          break;
        case "fortnight":
            cashflowMax = cashflowMax * clientConfig.params.frequency.fortnight
          break;
        case "month":
            cashflowMax = cashflowMax * clientConfig.params.frequency.month
          break;
      }
      switch(target) {
        case "spareCash":
          if (this.typedSpareCashAmount > cashflowMax) {this.typedSpareCashAmount = cashflowMax;}
          break;
        case "contributionsBeforeTax":
          if (this.contributionsBeforeTax > cashflowMax) {this.contributionsBeforeTax = cashflowMax;}
          break;
        case "contributionsAfterTax":
          if (this.contributionsAfterTax > cashflowMax) {this.contributionsAfterTax = cashflowMax;}
          break;
      }
    },


    salaryBalanceCheck(){
      this.salaryBalance = this.annualSalary - this.annualContributionsBeforeTax - this.annualContributionsAfterTax - this.annualSpareCashAmount;
      // toggle Error Msg based on if contributions amount is greater than salary
      if (this.salaryBalance < 0) {
        this.contributionsIsGreaterThanSalary = true;
        this.$store.commit("setIsResultTabActive", false);
      } else {
        this.contributionsIsGreaterThanSalary = false;
        this.$store.commit("setIsResultTabActive", true);
      }
      if (this.debugMode) {
        console.log("salaryBalanceCheck money available: " + this.salaryBalance);
        console.log("setIsResultTabActive", this.isResultTabActive )
      }

      return this.salaryBalance;
    },
  },

  mounted() {
    this.triggerHeightCheck();
  },

}
</script>

<template>
  <MDBContainer fluid>
    <MDBRow class="p-0">

      <MDBCol md="11" class="main-content-wrapper contribution-wrapper">
        <div v-html="clientConfig.content.contributions.header"></div>
        <div v-html="clientConfig.content.contributions.content"></div>

        <MDBRow class="form-group contributions">
          <p class="subheading" tabindex="0">
            {{ clientConfig.content.contributions.extraContributionsHeading }}
          </p>
        </MDBRow>

        <MDBRow class="error-msg contributions" v-show="contributionsIsGreaterThanSalary">
          <div class="alert alert-danger" role="alert">
            <div v-html="clientConfig.content.contributions.contributionsAmountExceededSalaryError"></div>
          </div>
        </MDBRow>

        <MDBRow class="form-group contributions">
          <label for="currentContributions" tabindex="0">
            {{ clientConfig.content.contributions.extraContributionsLabel }}
          </label>
          <MDBCol sm="2" class="px-0">
            <select
              id="currentContribution"
              class="form-control select time-select"
              v-model="currentContributions"
            >
              <option value="true">Yes</option>
              <option selected value="false">No</option>
            </select>
          </MDBCol>
          <MDBCol></MDBCol>
        </MDBRow>

        <MDBRow class="form-group" v-if="currentContributions == 'true'">
          <label for="inputCurrentContribution" tabindex="0">
            {{ clientConfig.content.contributions.currentContributionsLabel }}
          </label>
          <MDBCol md="4">
            <label
              for="contributionBeforeTaxAmount"
              class="contribution-label"
              tabindex="0"
            >
              {{ clientConfig.content.contributions.beforeTaxLabel }}
            </label>
          </MDBCol>
          <MDBCol md="4">
            <cleave
              v-model.number.lazy="contributionsBeforeTax"
              :options="formatOptions.contributions"
              name="contributionsBeforeTax"
              type="text"
              id="contributionsBeforeTax"
              class="form-control"
              tabindex="0"

              @change="$enforceFieldMinMax($event, this.contributionsBeforeTaxFrequency)"
              :min="data.contributionsBeforeTax.min"
              :max="this.taxedFund ? Math.min(data.contributionsBeforeTax.max, this.annualSalary - (this.annualSalary * $div100(employerContributionRate)))  : this.annualSalary - (this.annualSalary * $div100(employerContributionRate))"
            ></cleave>
          </MDBCol>

          <MDBCol md="4">
            <select
              v-model="contributionsBeforeTaxFrequency"
              class="form-control select"
              tabindex="0"
              @change="enforceTargetAmountMinMax(this.contributionsBeforeTaxFrequency, this.taxedFund ? Math.min(data.contributionsBeforeTax.max, this.annualSalary - (this.annualSalary * $div100(employerContributionRate)))  : this.annualSalary - (this.annualSalary * $div100(employerContributionRate)) , 'contributionsBeforeTax' )"
            >
              <option value="year">per year</option>
              <option value="month">per month</option>
              <option selected value="fortnight">per fortnight</option>
              <option value="week">per week</option>
            </select>

          </MDBCol>
        </MDBRow>
        <MDBRow class="form-group" v-if="currentContributions == 'true'">
          <MDBCol md="4">
            <label
              for="contributionAfterTaxAmount"
              class="contribution-label"
               tabindex="0"
            >
              {{ clientConfig.content.contributions.afterTaxLabel }}
            </label>
          </MDBCol>
          <MDBCol md="4">
            <cleave
              v-model.number.lazy="contributionsAfterTax"
              :options="formatOptions.contributions"
              name="contributionsAfterTax"
              type="text"
              id="contributionsAfterTax"
              class="form-control"
              tabindex="0"

              @change="$enforceFieldMinMax($event, this.contributionsAfterTaxFrequency)"
              :min="data.contributionsAfterTax.min"
              :max="Math.min(data.contributionsAfterTax.max, this.annualSalary - this.annualContributionsBeforeTax) "
            ></cleave>
          </MDBCol>

          <MDBCol md="4">
            <select
              v-model="contributionsAfterTaxFrequency"
              class="form-control select"
              tabindex="0"
              @change="enforceTargetAmountMinMax(this.contributionsAfterTaxFrequency, Math.min(data.contributionsAfterTax.max, this.annualSalary - this.annualContributionsBeforeTax)  , 'contributionsAfterTax' )"
            >
              <option value="year">per year</option>
              <option value="month">per month</option>
              <option selected value="fortnight">per fortnight</option>
              <option value="week">per week</option>
            </select>

          </MDBCol>
        </MDBRow>

        <hr class="" />

        <MDBRow class="form-group contributions">
          <p class="subheading" tabindex="0">
            {{ clientConfig.content.contributions.spareCashflowHeading }}
          </p>
        </MDBRow>

        <MDBRow class="form-group">
          <label for="newContributions" tabindex="0">
            {{ clientConfig.content.contributions.spareCashflowLabel }}
          </label>
          <MDBCol md="5" class="">
            <div
              class="options"
              role="group"
              aria-label="Cash flow selection"
            >
              <!-- <input
                type="radio"
                class="btn-check"
                name="btnradio-new"
                id="btnradio1"
                autocomplete="off"
                checked
                value="200"
                v-model.number="spareCashAmount"
                @change="checkContributionAmt"
              />
              <label
                class="btn btn-outline-primary half option"
                for="btnradio1"
                v-if="(this.annualSalary - this.annualContributionsAfterTax - this.annualContributionsBeforeTax) > 10000"
                >
                $200
              </label>

              <input
                type="radio"
                class="btn-check"
                name="btnradio-new"
                id="btnradio2"
                autocomplete="off"
                value="500"
                v-model.number="spareCashAmount"
                @change="checkContributionAmt"
              />
              <label
                class="btn btn-outline-primary half option"
                for="btnradio2"
                v-if="(this.annualSalary - this.annualContributionsAfterTax - this.annualContributionsBeforeTax)  > 20000"
                >
                $500
              </label>

              <input
                type="radio"
                class="btn-check"
                name="btnradio-new"
                id="btnradio3"
                autocomplete="off"
                value="1000"
                v-model.number="spareCashAmount"
                @change="checkContributionAmt"
              />
              <label
                class="btn btn-outline-primary half option"
                for="btnradio3"
                v-if="(this.annualSalary - this.annualContributionsAfterTax - this.annualContributionsBeforeTax) > 60000"
                >
                $1000
              </label>

              <input
                type="radio"
                class="btn-check"
                name="btnradio-new"
                id="btnradio4"
                autocomplete="off"
                :value="true"
                v-model.number="otherSpareCashAmount"
                @change="checkContributionAmt"
                @click="updateContributionAmountDelayed"
              />
              <label
                class="btn btn-outline-primary half option"
                for="btnradio4"
              >
                Other
              </label> -->

              <cleave
                v-model.number.lazy="typedSpareCashAmount"
                :options="formatOptions.contributions"
                name="typedSpareCashAmount"
                type="text"
                id="typedSpareCashAmount"
                class="form-control"
                tabindex="0"
                placeholder="$0"
                @change="$enforceFieldMinMax($event,this.spareCashAmountFrequency)"
                :min="data.spareCashAmount.min"
                :max="this.taxedFund ? (this.annualSalary - this.annualContributionsAfterTax - this.annualContributionsBeforeTax)  * data.spareCashflowLimiterTaxedFund : (this.annualSalary - this.annualContributionsAfterTax - this.annualContributionsBeforeTax) * data.spareCashflowLimiterUntaxedFund "
              ></cleave>

            </div>
          </MDBCol>
        </MDBRow>


        <label for="contributionFrequencyLabel" tabindex="0">
          {{ clientConfig.content.contributions.contributionFrequencyLabel }}
        </label>

        <MDBRow class="">
          <MDBCol md="5" class="form-group">
            <select
              v-model="spareCashAmountFrequency"
              class="form-control select"
              @change="enforceTargetAmountMinMax(this.spareCashAmountFrequency, this.taxedFund ? (this.annualSalary - this.annualContributionsAfterTax - this.annualContributionsBeforeTax)  * data.spareCashflowLimiterTaxedFund : (this.annualSalary - this.annualContributionsAfterTax - this.annualContributionsBeforeTax) * data.spareCashflowLimiterUntaxedFund , 'spareCash' )"
            >
              <option value="year">Yearly</option>
              <option value="month">Monthly</option>
              <option selected value="fortnight">Fortnightly</option>
              <option value="week">Weekly</option>
            </select>
          </MDBCol>
        </MDBRow>

        <MDBRow>
          <MDBCol md="11" class="text-center mx-auto my-5">
            <MDBBtn
              outline="secondary"
              class="rounded me-2"
              @click="clickToTab(2)"
              aria-label="Back button"
            >
              {{ clientConfig.content.contributions.backButtonLabel }}
            </MDBBtn>

            <MDBBtn
              color="primary"
              class="rounded next"
              :disabled="contributionsIsGreaterThanSalary || (typedSpareCashAmount + contributionsBeforeTax + contributionsAfterTax) == 0 "
              @click="clickToTab(4)"
              aria-label="Continue button"
            >
              {{ clientConfig.content.contributions.nextButtonLabel }}
              <i class="fas icon-arrow"></i>
            </MDBBtn>
          </MDBCol>
        </MDBRow>
      </MDBCol>
    </MDBRow>
  </MDBContainer>
</template>
